/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CommunityLibraryPublishingSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('COMMUNITY_LIBRARY_PUBLISHING')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CommunityLibraryPublishingSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CommunityLibraryPublishingSettingParser.decode(input).map(res => new CommunityLibraryPublishingSetting(res));
    }
    static unsafeDecode(input) {
        return CommunityLibraryPublishingSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CommunityLibraryPublishingSettingParser.encode(data);
    }
    static schema() {
        return CommunityLibraryPublishingSettingParser.schema();
    }
}
